//Componentes generales
import React, { useState, useEffect, useContext } from "react";
import AutocompleteV2 from "../AutoCompleteV2/AutoCompleteV2";

// Estilos
import './NewProductItm.css'
import { SECUNDARY_COLOR } from '../../constants/colors';

// Iconos
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBackspace } from "@fortawesome/free-solid-svg-icons";
import FormSistema from "../FromSistema/FormSistema";
import FormSubsistema from "../FromSubsistema/FromSubsistema";
import Swal from "sweetalert2";

//Contex
import sistemaContext from '../../context/sistemaContex/sistemaContext';
import subsistemaContext from '../../context/subsistemaContex/subsistemaContext';


/*
    Componente encargado de toda la logica del ingreso de un nuevo item en carga de requerimiento.
        Donde data es el item en el cual esta posicionado.
              index es la posición del item.
              productList es la lista de productos disponibles.
              agregaItem es la función que agrega el nuevo item.
              modificaItm es la función que modifica el item.
              borraItem es la función que borra el item.
*/
function NewProductItm({ data, index, productsList, agregaItem, modificaItm = () => console.log('modifica'), borraItem = () => console.log('elimina'), modo, componentePadre }) {
    
    //context sistema
    const { sistema, actualizarSistema } = useContext(sistemaContext);
    const { subsistema } = useContext(subsistemaContext);

    //Compartido por FormSubsistema y por FormSistema para saber si se debe setear un objeto vacio o usar el del item. 
    //true == add ; false == edit.
    const [addOrEditForm,setAddOrEditForm] = useState(true);
    
    const [sisOptions,setSisOptions] = useState({optionsSistemas:[sistema],optionsSubsistema:[subsistema]});

    const createOptions = () =>{
        let optionsSistemasModelados = sistema?.map((dato) => ({ value: dato.name, label: dato.name, _id: dato._id, codSistema: dato.codSistema, name: dato.name }));
        let optionsSubsistemasModelados = [];
        if(data?.sistema?._id != undefined){
            optionsSubsistemasModelados = subsistema?.filter(subsystem => subsystem.sistemaID === data?.sistema?._id)?.map((dato) => ({ value: dato.name, label: dato.name, _id: dato._id, codSubsistema: dato.codSubsistema, sistemaID: dato.sistemaID, name: dato.name }));
        }
        setSisOptions({optionsSistemas:optionsSistemasModelados, optionsSubsistema:optionsSubsistemasModelados});
    }

    useEffect(()=>{
        createOptions();
    },[sistema,subsistema])

    const [selected, setSelected] = useState( (componentePadre != 'Procedimiento') ? data?.sistema?.value !== '' ? data : {
            ...data,
            sistema: { value: "", label: "", id: '', name: '', codSistema: '' },
            subsistema: { value: "", label: "", id: '', sistemaID: '', name: '', codSubsistema: '', sistemaID: selected?.sistema }
        } : {...data}
    )

    const [showSistema, setShowSistema] = useState(false)
    //Se incrementa para remontar el autocompletado y que vuelva a mostrar el producto del item (ODT: no se permite cambiar un producto por otro).
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const [showSubsistema, setShowSubsistema] = useState(false)

    // se utiliza para que los items vayan cambiando su valor 
    useEffect(() => {
        setSelected({
            ...data,
            sistema: { value: data?.sistema?.name, label: data?.sistema?.name, _id: data?.sistema?._id, name: data?.sistema?.name, codSistema: data?.sistema?.codSistema },
            subsistema: {
                value: data?.subsistema?.name, label: data?.subsistema?.name, _id: data?.subsistema?._id,
                name: data?.subsistema?.name, codSubsistema: data?.subsistema?.codSubsistema, sistemaID: data?.sistema
            }
        })
    }, [data])

    /* 
        Manejador encargado de la logica del autocompletado ante una modificación.
            Donde value es el valor ingresado por el usuario.
    */

    const handlerChangeAutoComplete = (value) => {

        const indice = index;
        const productoSeleccionado = productsList.find((p) => `${p.tipPro}${p.artCod}`.replace(/\s+/g, '') === value.split(" ~ ")[0].replace(/\s+/g, ''));

        //se agrega a estructura_producto esta info.
        /*
            ODT con un producto ya cargado en el item:
                - Si se vuelve a elegir el mismo producto se actualiza con los datos actuales del ABM (descripción, código reducido y precio), manteniendo cantidad y descripción adicional.
                - Si se elige otro producto no se reemplaza: se avisa y se vuelve a mostrar el producto original.
        */
        if(componentePadre == 'FormReq' && data?.tipPro){
            if(productoSeleccionado && productoSeleccionado.tipPro == data.tipPro && productoSeleccionado.artCod == data.artCod){
                const actualizado = {
                    ...data,
                    codRed: productoSeleccionado.codRed ?? "",
                    descrp: productoSeleccionado.descrp ?? "",
                    precio: productoSeleccionado.precio ?? "",
                    productID: productoSeleccionado._id ?? ""
                };
                agregaItem(actualizado, indice);
                setSelected({ ...actualizado, sistema: selected.sistema, subsistema: selected.subsistema });
            }else{
                if(productoSeleccionado){
                    Swal.fire({
                        icon: 'info',
                        title: 'No se puede cambiar el producto',
                        text: 'Para usar otro producto elimine este ítem y agréguelo en uno nuevo.',
                        confirmButtonColor: '#3d4d87'
                    });
                }
                setAutocompleteKey(k => k + 1);
            }
            return;
        }

        const s = {
            ...data,
            tipPro: productoSeleccionado?.tipPro === undefined ? "" : productoSeleccionado?.tipPro,
            artCod: productoSeleccionado?.artCod === undefined ? "" : productoSeleccionado?.artCod,
            codRed: productoSeleccionado?.codRed === undefined ? "" : productoSeleccionado?.codRed,
            descrp: productoSeleccionado?.descrp === undefined ? "" : productoSeleccionado?.descrp,
            precio: productoSeleccionado?.precio === undefined ? "" : productoSeleccionado?.precio,
            productID: productoSeleccionado?._id === undefined ? "" : productoSeleccionado?._id
        };

        if (data?.artCod !== "" && s.artCod !== "") {
            if(componentePadre != 'Procedimiento' || componentePadre != 'Activo') modificaItm(s, indice, data);
            else agregaItem(s,index);
        } else {
            if (s?.artCod !== "") agregaItem(s, indice)
        }
        setSelected({ ...s, sistema: selected.sistema, subsistema: selected.subsistema });
    }

    /* 
        Manejador encargado de la modificación de la cantidad del item.
            Donde cantid es el valor ingresado por el usuario.
    */
    const handleChangeQuantity = (cantid) => {
        const indice = index;
        if (cantid > 0) {
            const s = { ...selected, quantity: cantid };
            setSelected(s);
            if(componentePadre != 'Procedimiento' && componentePadre != 'Activo' && componentePadre != 'FormConsumo' && componentePadre != 'FormOPD') modificaItm(s, indice, s);
            else {
                //En Procedimientos.js la misma funcion encargada de agregar productos tambien modifica sus propiedades.                            
                agregaItem(s,indice); 
            } 
        }
    }

    /* 
        Manejador encargado de la modificación del texto del item.
            Donde texto es el valor ingresado por el usuario.
    */
    const handleChangeTextAdic = (texto) => {
        const indice = index;
        const s = { ...selected, textAdic: texto };
        setSelected(s);
        modificaItm(s, indice, s);
    }

    const handleChangeSistema = (sistema) => {
        if(componentePadre == 'Activo' || componentePadre == 'FormReq'){
            agregaItem({},index,'sistema',{...sistema, subsistema: ""});
            agregaItem({},index,'subsistema',{undefined});
            createOptions();
        }else{
            const indice = index;
            const s = { ...selected, sistema: sistema};
            setSelected(s);
            modificaItm(s, indice, s);
        }
    }

    const handleChangeSubsistema = (subsistema) => {
        if(componentePadre == 'Activo' || componentePadre == 'FormReq'){
            agregaItem({},index,'subsistema',{...subsistema});
        }else{
            const s = { ...selected, subsistema: subsistema };
            const indice = index;
            setSelected(s);
            modificaItm(s, indice, s);
        }
    }

    const inputStyle = { margin: 4, textAlign: "center", fontWeight: 600, fontSize: 20, borderRadius: 5, border: 'none', boxShadow: 'rgba(148, 142, 142, 0.59) 4px 5px 5px 0px ' };

    // En la ODT el item se muestra en dos filas: producto + descripción adicional, y debajo cantidad + precio.
    // El precio se toma del ABM al elegir el producto y el usuario puede modificarlo antes de guardar la ODT.
    if(componentePadre == 'FormReq'){
        return (
            <div className="container-row-form-item header productoODT">
                <div className="container-row-form-item">
                    <div>
                        {
                            modo !== "Vista" && (
                                <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '40px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={() => borraItem(data,index)} />
                            )
                        }
                    </div>

                    <div className="input-autocomplete-form-item" style={{ width: "30%", flexGrow: 1 }}>
                        <AutocompleteV2 key={autocompleteKey} placeholder={"Ingrese un producto"} 
                        height={"60px"} value={(selected.tipPro !== "") ? `${selected.tipPro} ${selected.artCod} ~ ${selected.descrp}` : ""} setValue={handlerChangeAutoComplete} dataSuggestions={productsList.map((p) => { return { code: `${p.tipPro} ${p.artCod}`, descrp: `${p.descrp} (${p.codRed})` } })} />
                    </div>

                    <input
                    value={data.textAdic}
                    disabled={modo === 'Vista'}
                    placeholder={modo === 'Vista' ? "" : "Ingrese una descripción adicional"}
                    onChange={(e) => agregaItem({},index,'textAdic',e.target.value)}
                    style={{ fontSize: '1.7rem', width: "5%", height:"60px", fontWeight: 600, flexGrow: 1, margin: 4, borderRadius: 5, border: 'none', boxShadow: 'rgba(148, 142, 142, 0.59) 4px 5px 5px 0px ' }}/>
                </div>

                <div className="container-row-form-item cantidadPrecio">
                    <label>Cantidad</label>
                    <input
                    value={data.quantity === 0 ? 1 : data.quantity}
                    type="number"
                    placeholder="Cantidad"
                    disabled={modo === 'Vista'}
                    onChange={(e) => agregaItem({},index,'quantity',e.target.value)}
                    style={{ ...inputStyle, width: 150 }}
                    />
                    <label>Precio unitario $</label>
                    <input
                    value={data.precio ?? ''}
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    disabled={modo === 'Vista' || data.tipPro === ''}
                    onChange={(e) => agregaItem({},index,'precio',e.target.value === '' ? '' : Number(e.target.value))}
                    style={{ ...inputStyle, width: 200 }}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="container-row-form-item header">
            <div className="container-row-form-item">
                <div>
                    {
                        modo !== "Vista" && (
                            <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '40px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={() => (!["Procedimiento", 'Activo', 'FormReq', 'FormConsumo', 'FormOPD'].includes(componentePadre)) ? borraItem : borraItem(data,index)} />
                        )
                    }

                </div>

                <div className="input-autocomplete-form-item" style={{ width: "30%", flexGrow: 1 }}>
                    <AutocompleteV2 placeholder={"Ingrese un producto"} 
                    height={"60px"} value={(selected.tipPro !== "") ? `${selected.tipPro} ${selected.artCod} ~ ${selected.descrp}` : ""} setValue={handlerChangeAutoComplete} dataSuggestions={productsList.map((p) => { return { code: `${p.tipPro} ${p.artCod}`, descrp: `${p.descrp} (${p.codRed})` } })} />
                </div>

                {(componentePadre == 'Procedimiento' || componentePadre == 'Activo' || componentePadre == 'FormReq') ? 
                    <input
                    value={data.quantity === 0 ? 1 : data.quantity}
                    type="number"
                    placeholder="Cantidad"
                    disabled={modo === 'Vista'}
                    onChange={(datat) => agregaItem({},index,'quantity',datat.target.value)}
                    style={{ width:150, margin: 4, textAlign: "center", fontWeight: 600, fontSize: 20, borderRadius: 5, border: 'none', boxShadow: 'rgba(148, 142, 142, 0.59) 4px 5px 5px 0px ' }}
                    /> 
                : 
                    <input
                    value={selected.quantity === 0 ? 1 : selected.quantity}
                    type="number"
                    placeholder="Cantidad"
                    disabled={modo === 'Vista'}
                    onChange={(datat) => handleChangeQuantity(datat.target.value)}
                    style={{ width:150, margin: 4, textAlign: "center", fontWeight: 600, fontSize: 20, borderRadius: 5, border: 'none', boxShadow: 'rgba(148, 142, 142, 0.59) 4px 5px 5px 0px ' }}
                    />
                }

                {['FormConsumo','Procedimiento','Activo','FormReq','FormOPD'].includes(componentePadre) ? 
                    <input
                    value={data.textAdic}
                    disabled={modo === 'Vista'}
                    placeholder={modo === 'Vista' ? "" : "Ingrese una descripción adicional"}
                    onChange={(e) => agregaItem({},index,'textAdic',e.target.value)}
                    style={{ fontSize: '1.7rem', width: "5%", height:"60px", fontWeight: 600, flexGrow: 1, margin: 4, borderRadius: 5, border: 'none', boxShadow: 'rgba(148, 142, 142, 0.59) 4px 5px 5px 0px ' }}/> 
                : 
                    <input
                    value={selected.textAdic}
                    disabled={modo === 'Vista'}
                    placeholder={modo === 'Vista' ? "" : "Ingrese una descripción adicional"}
                    onChange={(datat) => handleChangeTextAdic(datat.target.value)}
                    style={{ fontSize: '1.7rem', width: "5%", height:"60px", fontWeight: 600, flexGrow: 1, margin: 4, borderRadius: 5, border: 'none', boxShadow: 'rgba(148, 142, 142, 0.59) 4px 5px 5px 0px ' }}/>
                }
            </div>
            {
                componentePadre == 'FormConsumo' && <div className="container-row-form-item cantDiaPromedio">
                    <label>Promedio por día: </label> <input value={data.promedioDia} disabled/>
                </div>
            }

            

            {
                (modo !== "Home" &&  componentePadre !== "Procedimiento" && componentePadre !== 'FormReq' && componentePadre !== 'FormConsumo' && componentePadre !== 'FormOPD') &&

                <>
                {/* Select Sistema */}
                    <Select
                        styles={{
                            input: (base) => ({
                                ...base,
                                width: '100%',
                                padding: '.4rem',
                                borderRadius: '.5rem',
                                fontSize: '1.3rem',
                                fontWeight: 600,
                                transition: 'border-color .5s',
                                width: '180px'
                            }),
                            placeholder: (base) => ({
                                ...base,
                                fontSize: '1.5rem',
                                fontWeight:"600" 
                            }),
                            singleValue: (base) => ({
                                ...base,
                                fontSize: '1.5rem',
                                fontWeight:"600"
                            }),
                            menu: (base) => ({
                                ...base,
                                fontSize: '1.5rem',
                                fontWeight:"600"
                            })
                        }}
                        options={sisOptions.optionsSistemas}
                        isDisabled={modo === 'Vista'}
                        value={data?.sistema?.name !== undefined ? data.sistema : ""}
                        placeholder={data?.sistema?.name !== undefined ? data?.sistema?.name : "Ingrese un sistema"}
                        onChange={(selectedOption) => handleChangeSistema(selectedOption)}
                    />
                    <div className="container-btn-sistema">

                        {
                            modo !== "Vista" && (
                                <>
                                    <button className='btn-sistema-mas' style={{ backgroundColor: SECUNDARY_COLOR, width:"40px", height:"25px", marginLeft: '5px' }} onClick={() => {setAddOrEditForm(true);setShowSistema(true);}}>+</button>

                                    {data?.sistema?.name !== undefined &&
                                        <button className='btn-sistema-menos' style={{ backgroundColor: 'green', marginLeft: '10px', marginTop:"4px", width:"40px", height:"25px" }} onClick={() => {setAddOrEditForm(false); setShowSistema(true);}}><FontAwesomeIcon icon={faPen} /></button>}
                                </>
                            )
                        }


                    </div>

                    {/* Select Sub-Sistema */}
                    <Select
                        styles={{
                            //boxShadow: 'rgba(148, 142, 142, 0.59) 4px 5px 5px 0px',
                            input: (base) => ({
                                ...base,
                                width: '100%',
                                padding: '.4rem',
                                borderRadius: '.5rem',
                                fontSize: '1.3rem',
                                fontWeight: 600,
                                transition: 'border-color .5s',
                                width: '180px',
                            }),
                            placeholder: (base) => ({
                                ...base,
                                fontSize: '1.5rem', 
                                fontWeight:"600" 
                            }),
                            singleValue: (base) => ({
                                ...base,
                                fontSize: '1.5rem',
                                fontWeight:"600"
                            }),
                            menu: (base) => ({
                                ...base,
                                fontSize: '1.5rem',
                                fontWeight:"600"
                            })
                        }}
                        options={sisOptions.optionsSubsistema}
                        isDisabled={modo === 'Vista'}
                        value={data?.subsistema?.value !== undefined ? data.subsistema : ""}
                        placeholder={data?.subsistema?.value !== undefined ? "" : "Ingrese un subsistema"}
                        onChange={(selectedOption) => handleChangeSubsistema(selectedOption)}
                    />
                    <div className="container-btn-sistema">

                        { modo !== "Vista" && <button className='btn-sistema-mas' style={{ backgroundColor: SECUNDARY_COLOR, width:"40px", height:"25px", marginLeft: '5px' }} onClick={() => { setShowSubsistema(true); setAddOrEditForm(true);}}>+</button>}
                            
                        {(modo !== "Vista" && data?.subsistema?.name !== undefined) && <button className='btn-sistema-menos' style={{ backgroundColor: 'green', marginLeft: '10px', marginTop:"4px", width:"40px", height:"25px" }}
                        onClick={() => {setShowSubsistema(true);setAddOrEditForm(false)}}>
                            <FontAwesomeIcon icon={faPen} />
                        </button>
                        }
                    </div>
                </>
            }
            {showSistema &&
                <div className='modalUser'>
                    <FormSistema
                        minimizar={(dato) => (setShowSistema(false), setSelected({ ...selected, sistema: dato }))}
                        data={data.sistema}
                        datoSistema={data.sistema}
                        addOrEditForm={addOrEditForm}
                        handleChangeSistema={handleChangeSistema}
                    />
                </div>
            }

            {showSubsistema &&
                <div className='modalUser'>
                    <FormSubsistema
                        minimizar={(dato) => (setShowSubsistema(false), setSelected({ ...selected, subsistema: dato }))}
                        data={data.subsistema}
                        sistemaSelected={data.sistema}
                        optionsSistema={sisOptions.optionsSistemas}
                        addOrEditForm={addOrEditForm}
                        handleChangeSubsistema={handleChangeSubsistema}
                    />
                </div>
            }

        </div>
    );
}

export default NewProductItm


